import types from './types';
import moment from 'moment';

const initialState = {
  byMonth: {},
  meta: {
    fetchingEvents: false,
    creatingEvent: false
  }
};

export const eventsReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_EVENTS_REQUEST: {
      return {
        ...state,
        meta: {
          ...state.meta,
          fetchingEvents: true
        }
      };
    }
    case types.GET_EVENTS_SUCCESS: {
      return {
        ...state,
        meta: {
          ...state.meta,
          fetchingEvents: false
        },
        byMonth: {
          ...state.byMonth,
          [action.monthYear]: {
            events: action.events,
            birthdays: action.birthdays
          }
        }
      };
    }
    case types.GET_EVENTS_FAILURE: {
      return {
        ...state,
        meta: {
          ...state.meta,
          fetchingEvents: false
        }
      };
    }
    case types.SAVE_EVENT_REQUEST: {
      return {
        ...state,
        meta: {
          ...state.meta,
          creatingEvent: true
        }
      };
    }
    case types.SAVE_EVENT_SUCCESS: {
      const { event, isExistingEvent } = action;
      const { date, id } = event;
      const byMonthCopy = { ...state.byMonth };
      const objectKey = moment(date).format('YYYY-MM');

      if (isExistingEvent) {
        // map `events` array to array of ids to get existing index
        const indexToUpdate = byMonthCopy[objectKey]['events'].map(event => event.id).indexOf(id);
        byMonthCopy[objectKey]['events'][indexToUpdate] = event;
      } else {
        if (byMonthCopy[objectKey]) {
          byMonthCopy[objectKey]['events'].push(event);
        } else {
          byMonthCopy[objectKey]['events'] = [event];
        }
      }

      return {
        ...state,
        byMonth: byMonthCopy,
        meta: {
          ...state.meta,
          creatingEvent: false
        }
      };
    }
    case types.SAVE_EVENT_FAILURE: {
      return {
        ...state,
        meta: {
          ...state.meta,
          creatingEvent: false
        }
      };
    }
    default:
      return state;
  }
};
